import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { TimeUtil } from '../../../../../util/TimeUtil';
import './NoteListCardItem.css';

interface NoteListCardItemProps {
  item: {
    id: string | number;
    name: string;
    created: string | number;
  };
  type: 'notebook' | 'note';
  onClick: (item: any) => void;
  className?: string;
  [key: string]: any; // For additional props like data-bs-dismiss
}

const NoteListCardItem: React.FC<NoteListCardItemProps> = ({
  item,
  type,
  onClick,
  className = '',
  ...otherProps
}) => {
  const handleClick = () => {
    onClick(item);
  };

  const getIcon = () => {
    return type === 'notebook' ? faBook : faStickyNote;
  };

  return (
    <div
      className={`note-list-card-item ${className}`}
      onClick={handleClick}
      {...otherProps}
    >
      <div className="card-icon">
        <FontAwesomeIcon icon={getIcon()} />
      </div>
      <div className="card-content">
        <div className="card-title">{item.name}</div>
        <div className="card-meta">
          <div className="card-date">
            {TimeUtil.formatDate(item.created)}
          </div>
          <div className="card-ago">
            {TimeUtil.formatAgo(item.created)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoteListCardItem;